import React from "react";
import '../css/Footer.css'

const Footer: React.FC = () => {
    return(
            <footer>
                <div className="container">
                    <div className="social-icons">
                       <a href="https://www.linkedin.com/in/stephanierjeter/"  target="_blank" rel="noreferrer"><i className="fa-brands fa-linkedin"></i></a>
                       <a href="https://www.instagram.com/stephy_jeter/" target="_blank" rel="noreferrer"><i className="fa-brands fa-instagram"></i></a>
                    </div>
                    <p>Copyright © {new Date().getFullYear()}. Designed and Developed by Stephanie Jeter.</p>
                </div>
            </footer>
    );
}

export default Footer;